var Backbone = require('backbone');

var Invoice = Backbone.Model.extend({
    idAttribute: "_id"
});

export default Invoice;
